import SceneTemplate from '../../components/scene-template'
import { BTN_ENDGAME_CONFIG, COLORS, TOOLBOX_CONFIG } from '../../constants/game'
import { WORD_LIST, WORD_LIST_2, BACKGROUND_CONTEXT, WORD_LIST_3 } from './bedroom.constants'

const overrideStyle = () => {
  // OVERRIDE COLORS
  TOOLBOX_CONFIG.fillColor = COLORS.primaryPink;
  BTN_ENDGAME_CONFIG.fillColor = COLORS.primaryBlue;
}
export class Bedroom extends SceneTemplate {
  constructor() {
    super('bedroom', WORD_LIST, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Habitacion'
  }
}

export class Bedroomv2 extends SceneTemplate {
  constructor() {
    super('bedroomv2', WORD_LIST_2, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Habitacion'
  }
}

export class Bedroomv3 extends SceneTemplate {
  constructor() {
    super('bedroomv3', WORD_LIST_3, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Habitacion'
  }
}